export default __webpack_public_path__ + "static/media/cert-badge.3ba6f233.svg";